<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>
		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text>
			<z-photo ref="photo"
				v-model="item.files"
				:required="item.required"
				:min="item.min"
				:max="item.max"
			></z-photo>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'
import zPhoto from '@/components/banners/Photo3'

export default {
	mixins: [mixin],
	components: { zPhoto },
	methods: {
		validate() {
			return this.$refs.photo?.validate()
		}
		/* validate() {
			//console.log(this.$options.name, 'validate', this.$refs.form?.validate())
			

			//return this.$refs.form?.validate()
			const required 	= this.item?.required ? this.item.required : false;
			const min 		= this.item?.min;
			const max 		= this.item?.max;
			const filesCount = this.item?.files.length;

			console.log(this.$options.name, 'validate', 'required', required)

			//const mandatory = this.item?.mandatory ? this.item.mandatory : false;
			 
			const p = new Promise((resolve, reject) => {
				if(required && this.item?.files.length == 0) {
					resolve({errors: [], valid: false});
				} else {
					resolve({errors: [], valid: true});
				}
			});

			console.log(this.$options.name, 'validate', 'p' , p)

			return p
		}, */
	},
}
</script>
